import { Badge } from "~/components/ui/badge";
import { Checkbox } from "~/components/ui/checkbox";
import { textVariants } from "~/components/text";
import { TruncatedText } from "~/components/truncated-text";
import { cn } from "~/utils";
import type { ThemaFacetItem } from "./thema-code-filter-section";

export function getThemaCodeKind(value: string, kind?: string): string {
  if (kind) return kind;
  const firstChar = value.slice(0, 1);
  if (!firstChar) return "Qualifier";
  return firstChar.match(/[A-Za-z]/) ? "Subject" : "Qualifier";
}

export function ThemaCodeFilterSectionRow({
  item,
  name,
  checked,
  onCheckedChange,
}: {
  item: ThemaFacetItem;
  name: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}) {
  const kind = getThemaCodeKind(item.value, item.kind);
  const rowId = `checkbox-filter-${name}-${item.value}`;
  const label = item.label ?? item.value;

  return (
    <label
      htmlFor={rowId}
      data-testid={`checkbox-filter-${item.value}`}
      className="flex items-center gap-3 px-6 py-1.5 hover:bg-secondary-100 cursor-pointer"
    >
      <Checkbox
        checked={checked}
        id={rowId}
        className="ml-1 shrink-0"
        onMouseDown={(event) => {
          event.stopPropagation();
          event.preventDefault();
        }}
        onCheckedChange={(nextChecked) => {
          onCheckedChange(Boolean(nextChecked));
        }}
      />
      <TruncatedText
        text={item.value}
        className={cn(
          textVariants({ variant: "captionStrong", numeric: "mono" }),
          "block w-20 shrink-0",
        )}
      />
      <TruncatedText
        text={label}
        className={cn(
          textVariants({ variant: "body" }),
          "block min-w-0 flex-1",
        )}
      />
      <Badge variant="secondary" className="min-w-20 shrink-0 px-2 py-0.5">
        {kind}
      </Badge>
    </label>
  );
}
